import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门排行</h2>
          <p className="text-sm text-foreground-500 mt-2">热度飙升 · 万人追捧 · 每日更新</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 p-4 rounded-lg transition-all duration-200 cursor-pointer hover:bg-background-200/50"
              style={{ backgroundColor: 'oklch(var(--background-50))' }}
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className="font-heading text-lg font-bold"
                    style={{
                      color:
                        item.rank === 1
                          ? 'oklch(var(--primary-500))'
                          : item.rank === 2
                            ? 'oklch(var(--accent-500))'
                            : 'oklch(var(--secondary-500))',
                    }}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {item.author} · {item.category}
                </p>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="inline-block px-2.5 py-1 rounded text-xs font-medium" style={{ backgroundColor: 'oklch(var(--primary-100) / 0.6)', color: 'oklch(var(--primary-700))' }}>
                  {item.status}
                </span>
                <p className="text-xs mt-1" style={{ color: 'oklch(var(--accent-600))' }}>{item.hotIndex}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}